import styled from '@emotion/styled';

export const FilterRow = styled.div`
    display: flex;
    padding: 10px 0px;
    align-items: center;

    label {
        flex: 1;
        margin-right: 10px;
    }

    @media (max-width: 800px) {
        flex-direction: column;
        align-items: stretch;
    }
`;

export const selectStyles = {
    container: (styles) => ({
        ...styles,
        flex: 5
    })
};
